import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { FiltroCategoriaOs } from './filtro-categoria-os';
import { RetencaoVeiculoFiltroService } from './retencao-veiculo-filtro.service';
import { RetencaoVeiculoService } from './retencao-veiculo.service';
import { ServiceAppService } from '../../../security/service-app.service';
import { DatePipe, ViewportScroller } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-retencao-veiculo',
  templateUrl: './retencao-veiculo.component.html',
  styleUrls: ['./retencao-veiculo.component.scss']
})
export class RetencaoVeiculoComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  loading: boolean = false;
  displayFiltrosOS: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  filtrosCategoriaOs: FiltroCategoriaOs;
  display: boolean = false;
  cargaTela: boolean;
  totalQtdVisit: any;
  totalQtdCarParc: any;
  totalQtdRetention: any;
  totalChassis: number = 0;
  dadosAnaliticos: any;
  exibeAnalitico: boolean = false;

  firstAn: number = 0;
  displayRowsAn: number = 0;
  rowsAn: number = 10;

  columnsAnalytical: any[];
  _selectedColumnsAnalytical: any[];
  registroAnArmazenado: any;
  searchTimeout: any;

  drilldownVisible = false;
  drilldownLoading = false;
  drilldownNivel = 1;
  drilldown: any = {
    data_inicial: null,
    data_final: null,
    ano: null,
    ano_visita: null,
    mes_visita: null,
    id_padrao_veiculos: null,
    familia: null
  };
  dadosMensais: any[] = [];
  dadosFamilias: any[] = [];
  dadosDetalhe: any[] = [];
  firstDetalhe = 0;

  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartColors: any[] = [{
    backgroundColor: 'rgba(0, 152, 223, 0.7)',
    borderColor: 'rgb(0, 152, 223)',
    hoverBackgroundColor: 'rgba(0, 152, 223, 0.9)',
    borderWidth: 1
  }];
  public barChartMensalLabels: string[] = [];
  public barChartMensalData: any[] = [];
  public barChartMensalOptions: any = this.criarOpcoesGrafico();
  public barChartFamiliaLabels: string[] = [];
  public barChartFamiliaData: any[] = [];
  public barChartFamiliaOptions: any = this.criarOpcoesGrafico();

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Delivery Year": "businessIntelligence.retencaoVeiculo.deliveryYear",
    "Visit": "businessIntelligence.retencaoVeiculo.qtdVisit",
    "Car Parc": "businessIntelligence.retencaoVeiculo.qtdCarParc",
    "Retention": "businessIntelligence.retencaoVeiculo.retention"
  }

  constructor(private serviceVeiculo: RetencaoVeiculoService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: RetencaoVeiculoFiltroService,
    private service: ServiceAppService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder,
    private date: DatePipe,
    private scroller: ViewportScroller) {
    this.filtros = {};
    this.nomeModulo = 'retencao-veiculo';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.filtrosCategoriaOs = new FiltroCategoriaOs(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      categoria_os: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    this.loading = true;

    this.cols = [
      { field: 'delivery_year', header: 'businessIntelligence.retencaoVeiculo.deliveryYear', headerBr: 'Delivery Year', headerGb: 'Delivery Year' },
      { field: 'qtd_visit', header: 'businessIntelligence.retencaoVeiculo.qtdVisit', headerBr: 'Visit', headerGb: 'Visit' },
      { field: 'qtd_car_parc', header: 'businessIntelligence.retencaoVeiculo.qtdCarParc', headerBr: 'Car Parc', headerGb: 'Car Parc' },
      { field: 'chassiFaltante', header: 'businessIntelligence.retencaoVeiculo.chassiFaltante', headerBr: 'Chassis Faltantes', headerGb: 'Chassis Faltantes' },
      { field: 'retencao', header: 'businessIntelligence.retencaoVeiculo.retention', headerBr: 'Retention', headerGb: 'Retention' }
    ];

    this.columnsAnalytical = [
      { field: 'dataEmissao', header: 'Data Emissão', headerBr: 'Data Emissão', headerGb: 'Visit', type: this.date, arg1: 'dd/MM/yyyy' },
      { field: 'chassi', header: 'Chassi Faltante', headerBr: 'Chassi Faltante', headerGb: 'Delivery Year' },
      { field: 'nomeCliente', header: 'Nome', headerBr: 'Nome', headerGb: 'Chassis Faltantes' },
      { field: 'email', header: 'E-mail', headerBr: 'E-mail', headerGb: 'Car Parc' },
      { field: 'telefoneCelular', header: 'Telefone', headerBr: 'Telefone', headerGb: 'Retention' }
    ];

    this._selectedColumnsAnalytical = this.columnsAnalytical;
    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.filtrosCategoriaOs.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private getAll() {
    this.serviceVeiculo.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value
      , this.f.categoria_os.value
    ).subscribe(registros => {
      this.dealersDados = registros.dados;
      this.totalChassis = registros.totalChassis;
      this.countTotais(registros.dados);
      this.orderByDate();

      this.cargaTela = false;
    });
  }

  countTotais(event: any) {
    this.totalQtdVisit = event.reduce((sum, row) => sum + row.qtd_visit, 0);
    this.totalQtdCarParc = event.reduce((sum, row) => sum + row.qtd_car_parc, 0);

    this.totalQtdRetention = (this.totalQtdVisit / this.totalQtdCarParc) * 100;
    this.totalQtdRetention = parseFloat(this.totalQtdRetention.toFixed(3));

    this.loading = false;
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    dataInicio.setMonth(dataInicio.getMonth());
    dataInicio.setDate(0);
    this.dataInicial = dataInicio;

    const dataFim = new Date(dataInicio);
    dataFim.setDate(dataFim.getDate() - 365);
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.resetDrilldown();
    this.dadosAnaliticos = [];
    this.loading = true;

    const dataAtual = moment();
    const dataInicialMoment = moment(this.dataInicial);

    if (dataInicialMoment.isSame(dataAtual, 'month') && dataInicialMoment.isSame(dataAtual, 'year')) {
      this.f.data_inicial.setValue(moment().subtract(1, 'months').endOf('month').format('DD-MM-YYYY'));
    } else {
      this.f.data_inicial.setValue(dataInicialMoment.endOf('month').format('DD-MM-YYYY'));
    }

    const dataFinal = moment(this.f.data_inicial.value, 'DD-MM-YYYY').subtract(365, 'days').format('DD-MM-YYYY');
    this.f.data_final.setValue(dataFinal);

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];
    const categoriaOs = [];

    this.incluirFiltroDealers(dealers);
    this.incluirFiltroCategoriasOs(categoriaOs);

    this.filtros.dealers = dealers.map(r => r.valor);
    this.filtros.categoriaOs = categoriaOs.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }

    if (this.filtros.categoriaOs.length != 0) {
      this.f.categoria_os.setValue(this.filtros.categoriaOs[0]);
    } else {
      this.f.categoria_os.setValue('');
    }

  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.dealers.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public selecionarCategoriaOs() {
    this.displayFiltrosOS = true;
  }

  public removerCategoriaOs(categoria: any) {
    categoria.selecionado = false;
    const index = this.filtros.categoriaOs;
    if (index > -1) {
      this.filtros.categoriaOs.splice(index, categoria);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarCategoriaOsFiltro(categoria: any) {
    categoria.selecionado = true;
    const sel = [];

    this.incluirFiltroCategoriasOs(sel);
    this.filtros.categoriaOs = sel;
  }

  private incluirFiltroCategoriasOs(filtros: any[]) {
    if (this.filtrosCategoriaOs.selecionados().length > 0) {
      const item = { 'chave': 'categorias', 'valor': [] };
      this.filtrosCategoriaOs.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "businessIntelligence.retencaoVeiculo.deliveryYear") {
      return "Delivery Year";
    }
    if (item == "businessIntelligence.retencaoVeiculo.qtdVisit") {
      return "Visit";
    }
    if (item == "businessIntelligence.retencaoVeiculo.qtdCarParc") {
      return "Car Parc";
    }
    if (item == "businessIntelligence.retencaoVeiculo.chassiFaltante") {
      return "Chassis Faltantes";
    }
    if (item == "businessIntelligence.retencaoVeiculo.retention") {
      return "Retention";
    }
  }

  private translateField(item) {
    return item;
  }

  public exportExcel() {
    let registro = [];

    this.serviceVeiculo.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value
      , this.f.categoria_os.value
    ).subscribe(registros => {
      registro = registros.dados;
      this.orderByDate();

      if (registro.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;
        this.exportExcelService.ExportTOExcelJSON(registro.map(r => {
          let linha = {};

          this._selectedColumns.forEach(c => {
            linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
          });

          return linha;
        }));
      }
    });

    const filtro = this.registroAnArmazenado
      ? `dealers=${this.f.dealers.value}&ano=${this.registroAnArmazenado.delivery_year}&data_inicial=${this.f.data_inicial.value}&data_final=${this.f.data_final.value}&categoria_os=${this.f.categoria_os.value}`
      : `dealers=${this.f.dealers.value}&data_inicial=${this.f.data_inicial.value}&data_final=${this.f.data_final.value}&categoria_os=${this.f.categoria_os.value}`;

    let registroAn: any[] = [];
    this.service.getDados(`/retencao_veiculo/detalhe?${filtro}`).subscribe(res => {
      registroAn = res;
      registroAn.forEach(el => {
        el.dataEmissao = el.dataEmissao.replace('[UTC]', '');
        el.dataEmissao = moment(el.dataEmissao).format('DD/MM/YYYY');
      });

      if (registroAn.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo + ' analítico';
        this.exportExcelService.ExportTOExcelJSON(registroAn.map(r => {
          let linha = {};

          this._selectedColumnsAnalytical.forEach(c => linha[(c.header)] = (r[c.field]));

          return linha;
        }));
      }

    });

  }

  public getChassiFaltante(registroAn: any) {
    this.loading = true;
    this.registroAnArmazenado = registroAn;
    const filtro = registroAn
      ? `dealers=${this.f.dealers.value}&ano=${registroAn.delivery_year}&data_inicial=${this.f.data_inicial.value}&data_final=${this.f.data_final.value}&categoria_os=${this.f.categoria_os.value}`
      : `dealers=${this.f.dealers.value}&data_inicial=${this.f.data_inicial.value}&data_final=${this.f.data_final.value}&categoria_os=${this.f.categoria_os.value}`;

    this.service.getDados(`/retencao_veiculo/detalhe?${filtro}`).subscribe(res => {
      this.dadosAnaliticos = res;
      this.dadosAnaliticos.forEach(el => el.dataEmissao = el.dataEmissao.replace('[UTC]', ''));

      setTimeout(() => this.scroller.scrollToAnchor('dtAnalitico'), 200);

      this.loading = false;
    });

  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      });
  }

  public filtrarDealer(dealer: string): void {
    clearTimeout(this.searchTimeout);  // Limpa o timeout anterior

    this.searchTimeout = setTimeout(() => {
      if (dealer !== '') {
        this.filtrosDealers.dealers = this.filtrosDealers.dealers.filter(dealerItem => {
          return dealerItem.nome.toLowerCase().includes(dealer.toLowerCase());
        })
      } else {
        this.filtrosDealers.dealers = [];
        this.filtrosDealers.carregar();
      }
    }, 300);
  }

  get tituloDrilldown(): string {
    const primeiro = this.translate.instant('businessIntelligence.retencaoVeiculo.primeiroRetorno');
    if (this.drilldownNivel === 1) {
      return primeiro + ' — ' + this.drilldown.ano;
    }

    const mesLabel = this.labelMes(this.drilldown.ano_visita, this.drilldown.mes_visita);
    if (this.drilldownNivel === 2) {
      return this.translate.instant('businessIntelligence.retencaoVeiculo.familias') + ' — ' + mesLabel;
    }

    return this.translate.instant('businessIntelligence.retencaoVeiculo.ordensServico')
      + ' — ' + this.drilldown.familia + ' — ' + mesLabel;
  }

  public abrirDrilldownPrimeiroRetorno(registro: any) {
    this.limparEstadoDrilldown();
    this.drilldown.data_inicial = this.f.data_inicial.value;
    this.drilldown.data_final = this.f.data_final.value;
    this.drilldown.ano = registro.delivery_year;
    this.drilldownNivel = 1;
    this.drilldownVisible = true;
    this.carregarNivel1();
  }

  public voltarDrilldown() {
    if (this.drilldownNivel === 3) {
      this.drilldown.id_padrao_veiculos = null;
      this.drilldown.familia = null;
      this.dadosDetalhe = [];
      this.firstDetalhe = 0;
      this.drilldownNivel = 2;
      return;
    }

    if (this.drilldownNivel === 2) {
      this.drilldown.ano_visita = null;
      this.drilldown.mes_visita = null;
      this.dadosFamilias = [];
      this.barChartFamiliaData = [];
      this.barChartFamiliaLabels = [];
      this.drilldownNivel = 1;
    }
  }

  public resetDrilldown() {
    this.drilldownVisible = false;
    this.limparEstadoDrilldown();
  }

  public limparEstadoDrilldown() {
    this.drilldownLoading = false;
    this.drilldownNivel = 1;
    this.drilldown = {
      data_inicial: null,
      data_final: null,
      ano: null,
      ano_visita: null,
      mes_visita: null,
      id_padrao_veiculos: null,
      familia: null
    };
    this.dadosMensais = [];
    this.dadosFamilias = [];
    this.dadosDetalhe = [];
    this.firstDetalhe = 0;
    this.barChartMensalData = [];
    this.barChartMensalLabels = [];
    this.barChartFamiliaData = [];
    this.barChartFamiliaLabels = [];
  }

  private carregarNivel1() {
    this.drilldownLoading = true;
    this.serviceVeiculo.getPrimeiroRetornoMensal(
      this.drilldown.data_inicial,
      this.drilldown.data_final,
      this.drilldown.ano
    ).subscribe(res => {
      this.dadosMensais = this.completarMeses(res && res.dados ? res.dados : []);
      this.montarGraficoMensal();
      this.drilldownLoading = false;
    }, () => {
      this.dadosMensais = [];
      this.montarGraficoMensal();
      this.drilldownLoading = false;
    });
  }

  public onChartMensalClick(event: any) {
    const index = this.indiceBarraClicada(event);
    if (index != null) {
      this.onClickMes(index);
    }
  }

  public onChartFamiliaClick(event: any) {
    const index = this.indiceBarraClicada(event);
    if (index != null) {
      this.onClickFamilia(index);
    }
  }

  public onClickMes(index: number) {
    if (index == null || !this.dadosMensais[index]) {
      return;
    }

    const mes = this.dadosMensais[index];
    this.drilldown.ano_visita = mes.ano_visita;
    this.drilldown.mes_visita = mes.mes_visita;
    this.carregarNivel2();
  }

  private carregarNivel2() {
    this.drilldownLoading = true;
    this.serviceVeiculo.getPrimeiroRetornoFamilia(
      this.drilldown.data_inicial,
      this.drilldown.data_final,
      this.drilldown.ano,
      this.drilldown.ano_visita,
      this.drilldown.mes_visita
    ).subscribe(res => {
      const dados = res && res.dados ? res.dados : [];
      this.dadosFamilias = dados.filter(item => item.car_visit > 0);
      this.montarGraficoFamilia();
      this.drilldownNivel = 2;
      this.drilldownLoading = false;
    }, () => {
      this.dadosFamilias = [];
      this.montarGraficoFamilia();
      this.drilldownNivel = 2;
      this.drilldownLoading = false;
    });
  }

  public onClickFamilia(index: number) {
    if (index == null || !this.dadosFamilias[index]) {
      return;
    }

    const familia = this.dadosFamilias[index];
    this.drilldown.id_padrao_veiculos = familia.id_padrao_veiculos;
    this.drilldown.familia = familia.familia;
    this.carregarNivel3();
  }

  private carregarNivel3() {
    this.drilldownLoading = true;
    this.serviceVeiculo.getPrimeiroRetornoFamiliaDetalhe(
      this.drilldown.data_inicial,
      this.drilldown.data_final,
      this.drilldown.ano,
      this.drilldown.ano_visita,
      this.drilldown.mes_visita,
      this.drilldown.id_padrao_veiculos
    ).subscribe(res => {
      const dados = res && res.dados ? res.dados : [];
      this.dadosDetalhe = dados.map(item => this.mapearDetalheOs(item));
      this.firstDetalhe = 0;
      this.drilldownNivel = 3;
      this.drilldownLoading = false;
    }, () => {
      this.dadosDetalhe = [];
      this.drilldownNivel = 3;
      this.drilldownLoading = false;
    });
  }

  public exportExcelDetalhe() {
    this.drilldownLoading = true;
    this.serviceVeiculo.getPrimeiroRetornoFamiliaDetalhe(
      this.drilldown.data_inicial,
      this.drilldown.data_final,
      this.drilldown.ano,
      this.drilldown.ano_visita,
      this.drilldown.mes_visita,
      this.drilldown.id_padrao_veiculos
    ).subscribe(res => {
      const dados = (res && res.dados ? res.dados : []).map(item => this.mapearDetalheOs(item));

      if (dados.length > 0) {
        const dealer = this.translate.instant('businessIntelligence.retencaoVeiculo.dealer');
        const numeroOs = this.translate.instant('businessIntelligence.retencaoVeiculo.numeroOs');
        const dataAbertura = this.translate.instant('businessIntelligence.retencaoVeiculo.dataAbertura');
        const dataEncerramento = this.translate.instant('businessIntelligence.retencaoVeiculo.dataEncerramento');
        const familiaLabel = this.drilldown.familia || '';

        this.exportExcelService.nomeModulo = this.nomeModulo + ' primeiro-retorno'
          + (familiaLabel ? ' ' + familiaLabel : '');
        this.exportExcelService.ExportTOExcelJSON(dados.map(r => {
          const linha = {};
          linha[dealer] = r.dealer;
          linha[numeroOs] = r.numero_ordem_servico;
          linha[dataAbertura] = r.data_abertura;
          linha[dataEncerramento] = r.data_encerramento;
          return linha;
        }));
      }

      this.drilldownLoading = false;
    }, () => {
      this.drilldownLoading = false;
    });
  }

  private mapearDetalheOs(item: any) {
    return {
      dealer: item.dealer,
      numero_ordem_servico: item.numero_ordem_servico,
      data_abertura: this.formatarDataEpoch(item.data_abertura),
      data_encerramento: this.formatarDataEpoch(item.data_encerramento)
    };
  }

  private montarGraficoMensal() {
    this.barChartMensalLabels = this.dadosMensais.map(item => this.labelMes(item.ano_visita, item.mes_visita));
    this.barChartMensalData = [{
      data: this.dadosMensais.map(item => item.car_visit),
      label: this.translate.instant('businessIntelligence.retencaoVeiculo.carVisit')
    }];
  }

  private montarGraficoFamilia() {
    this.barChartFamiliaLabels = this.dadosFamilias.map(item => item.familia);
    this.barChartFamiliaData = [{
      data: this.dadosFamilias.map(item => item.car_visit),
      label: this.translate.instant('businessIntelligence.retencaoVeiculo.carVisit')
    }];
  }

  private completarMeses(dados: any[]): any[] {
    if (!dados || dados.length === 0) {
      return [];
    }

    const ordenados = dados.slice().sort((a, b) => {
      if (a.ano_visita !== b.ano_visita) {
        return a.ano_visita - b.ano_visita;
      }
      return a.mes_visita - b.mes_visita;
    });

    const mapa = {};
    ordenados.forEach(item => {
      mapa[item.ano_visita + '-' + item.mes_visita] = item;
    });

    const primeiro = ordenados[0];
    const ultimo = ordenados[ordenados.length - 1];
    const preenchidos = [];
    let ano = primeiro.ano_visita;
    let mes = primeiro.mes_visita;

    while (ano < ultimo.ano_visita || (ano === ultimo.ano_visita && mes <= ultimo.mes_visita)) {
      const chave = ano + '-' + mes;
      preenchidos.push(mapa[chave] || { ano_visita: ano, mes_visita: mes, car_visit: 0 });
      mes++;
      if (mes > 12) {
        mes = 1;
        ano++;
      }
    }

    return preenchidos;
  }

  private labelMes(ano: number, mes: number): string {
    if (!ano || !mes) {
      return '';
    }
    return this.translate.instant('businessIntelligence.retencaoVeiculo.meses.' + mes) + '/' + ano;
  }

  private indiceBarraClicada(event: any): number {
    if (!event || !event.active || !event.active.length) {
      return null;
    }
    const ativo = event.active[0];
    if (ativo._index != null) {
      return ativo._index;
    }
    return ativo.index != null ? ativo.index : null;
  }

  private criarOpcoesGrafico(): any {
    const corPreta = '#000000';
    return {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        xAxes: [{
          ticks: {
            fontColor: corPreta,
            fontStyle: 'bold'
          },
          gridLines: { color: 'rgba(0, 0, 0, 0.08)' }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            precision: 0,
            fontColor: corPreta,
            fontStyle: 'bold'
          },
          gridLines: { color: 'rgba(0, 0, 0, 0.08)' }
        }]
      },
      plugins: {
        datalabels: {
          color: corPreta,
          font: {
            weight: 'bold'
          },
          anchor: 'center',
          align: 'center'
        }
      }
    };
  }

  private formatarDataEpoch(valor: any): string {
    if (valor == null || valor === '') {
      return '-';
    }

    const data = typeof valor === 'string' ? valor.replace('[UTC]', '') : valor;
    const parsed = moment(data);
    return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '-';
  }

}